import React from "react";

const StatusChip = ({ color, label }) => {
  return (
    <span className={`status__chip`} style={{ backgroundColor: color }}>
      {label}
    </span>
  );
};

export default StatusChip;
